import { render, staticRenderFns } from "./menu-content.vue?vue&type=template&id=cb767846&"
import script from "./menu-content.vue?vue&type=script&lang=js&"
export * from "./menu-content.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports